/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type {
  GenerateOnboardingServiceDescriptionApiArg,
  OnboardingGenerateServiceDescriptionResponse,
} from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    generateOnboardingServiceDescription: build.mutation<
      OnboardingGenerateServiceDescriptionResponse,
      GenerateOnboardingServiceDescriptionApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/onboarding/services/generate-description`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as generateOnboardingServiceDescriptionApi };
export const { useGenerateOnboardingServiceDescriptionMutation } = injectedRtkApi;
